module.exports = __webpack_public_path__ + "img/ok_btn.658a69db.png";